// NetworkProvider.js
import { createContext, useState, useEffect } from "react";

export const NetworkContext = createContext();

export const NetworkProvider = ({ children }) => {
  const [internetAvailable, setInternetAvailable] = useState(navigator.onLine);

  // Real internet check by pinging Google (or your own server)
  const checkInternetAccess = async () => {
    try {
      // Using favicon.ico to avoid CORS issues with GET
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 3000); // 3s timeout

      await fetch("https://www.google.com/favicon.ico", {
        method: "HEAD",
        mode: "no-cors", // this prevents CORS errors but still triggers the request
        signal: controller.signal,
      });

      clearTimeout(timeout);
      setInternetAvailable(true);
    } catch (err) {
      setInternetAvailable(false);
    }
  };

  useEffect(() => {
    const handleOnline = () => checkInternetAccess();
    const handleOffline = () => setInternetAvailable(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    // Initial check
    checkInternetAccess();

    // Periodically check every 10 seconds
    const interval = setInterval(checkInternetAccess, 10000);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
      clearInterval(interval);
    };
  }, []);

  return (
    <NetworkContext.Provider value={{ internetAvailable }}>
      {children}
    </NetworkContext.Provider>
  );
};
